import type { FieldDataSensitivity } from "metabase-types/api";

// A Record, so that adding a category to `FieldDataSensitivity` fails to compile until it is added here too.
const FIELD_DATA_SENSITIVITIES: Record<FieldDataSensitivity, true> = {
  SEC_KEY: true,
  SYS_TELEMETRY: true,
  PHI: true,
  BIO_GEN: true,
  PCI_FIN: true,
  SENS_PERS: true,
  PII: true,
  CORP_IP: true,
  BIZ_CONF: true,
  PUBLIC: true,
};

export const isFieldDataSensitivity = (
  value: string,
): value is FieldDataSensitivity =>
  Object.keys(FIELD_DATA_SENSITIVITIES).includes(value);
